import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizeAddressDetails: {
        id:'tfpa.policyChange.views.mailing.Standardize Address Details',
        defaultMessage: 'Standardize Address Details'
    },
    nonStandardizedMessage: {
            id:'tfpa.policyChange.views.mailing.nonStandardized',
            defaultMessage: 'The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue.'
    },
    standardizedMessage: {
        id:'tfpa.policyChange.views.mailing.standardized message',
        defaultMessage: 'The address you entered has been updated to follow USPS standards.'
    },
    standardized: {
        id:'tfpa.policyChange.views.mailing.isStandardized',
        defaultMessage: 'The address you entered has been standardized.'
    },
    overridden: {
        id:'tfpa.policyChange.views.mailing.overridden',
        defaultMessage: 'The address you entered could not be updated to follow USPS standards. You may be contacted for additional information.'
    },
    notStandardized: {
        id:'tfpa.policyChange.views.mailing.notStandardized',
        defaultMessage: 'The address you entered has not been standardized.'
    },
    PhoneValidationMessage: {
        id: 'tfpa.policyChange.views.mailing.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    state: {
        id:'tfpa.policyChange.views.mailing.country.State',
        defaultMessage: 'State'
    },
    US: {
        id:'tfpa.policyChange.views.mailing.country.US',
        defaultMessage: 'State'
    },
    CA: {
        id:'tfpa.policyChange.views.mailing.country.CA',
        defaultMessage: 'Province'
    },
    JP: {
        id:'tfpa.policyChange.views.mailing.country.JP',
        defaultMessage: 'Prefecture'
    },
    zipCode: {
        id:'tfpa.policyChange.views.mailing.ZIP Code',
        defaultMessage: 'ZIP Code'
    },
    postCode: {
        id:'tfpa.policyChange.views.mailing.Postcode',
        defaultMessage: 'Postcode'
    },
    postalCode : {
        id:'tfpa.policyChange.views.mailing.PostalCode',
        defaultMessage: 'Postal Code'
    },
    town: {
        id:'tfpa.policyChange.views.mailing.Town',
        defaultMessage: 'Town/City'
    },
    city: {
        id:'tfpa.policyChange.views.mailing.City',
        defaultMessage: 'City'
    },
    cityPhonetic: {
        id:'tfpa.policyChange.views.mailing.City Phonetic',
        defaultMessage: 'City (phonetic)'
    },
    emailValidationMessage: {
        id:'tfpa.policyChange.account.Email.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    phoneValidationMessage: {
        id:'tfpa.policyChange.account.PnoneNumber.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    stateMsg: {
        id:'tfpa.policyChange.wizard.residential.TWIA.Primary Location Address.State placeholder',
        defaultMessage: '-- Choose State --'
    },
    provinceMsg: {
        id:'tfpa.policyChange.wizard.residential.TWIA.Primary Location Address.Province placeholder',
        defaultMessage: '-- Choose Province --'
    },
    prefectureMsg: {
        id:'tfpa.policyChange.wizard.residential.TWIA.Primary Location Address.Prefecture placeholder',
        defaultMessage: '-- Choose Prefecture --'
    },
    required: {
        id:'tfpa.policyChange.wizard.residential.TWIA.required field',
        defaultMessage: 'This is a required field.',
    },
    ZIPCodeValidationMessage: {
        id:'tfpa.policyChange.wizard.residential.TWIA.Please enter a valid postal code.',
        defaultMessage: 'Please enter a valid postal code.',
    },
})